import React from "react"
import {createContext, useEffect, useState} from "react"
import Firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth"
import {useCollection, useCollectionData} from "react-firebase-hooks/firestore";
import CourseSchedule from "../../Models/CourseSchedule";
import Semester from "../../Models/Semester";
import Course from "../../Models/Course";

export const CoursesContext = createContext(undefined);

export const CoursesProvider = (props: any) => {

    const [user] = useAuthState(Firebase.auth());
    const [semesters, setSemesters] = useState<any>();

    let userID = user ? user.uid : 'null';

    const [courseData] = useCollection(
        Firebase
            .firestore()
            .collection('users')
            .doc(userID)
            .collection('courses')
    );
    const [termData] = useCollectionData(Firebase.firestore().collection('TermList'));

    const getTerms = (termData: any) => {
        let termObj: any = {};
        termData.forEach((term: any) => {
            termObj[term.code] = term
        });
        return termObj;
    };

    const isCurrentTerm = (term: any) => {
        if (term) {
            const date = new Date();
            const startDate = new Date(term.startDate);
            const endDate = new Date(term.endDate);
            return (date >= startDate && date < endDate);
        } else {
            return false
        }
    };

    const parseSemesters = (courseData: any, termData: any): Semester[] => {
        if (courseData && termData) {
            let semesters: any = {};
            let termCode: string;
            let schedule: CourseSchedule[];
            let course: Course;
            let courseInfo: any;
            let terms = getTerms(termData);

            courseData.docs.forEach((courseSnapShot: any) => {
                courseInfo = courseSnapShot.data();
                termCode = courseInfo.termCode;

                schedule = courseInfo.meet.map((scheduleData: any) => ({
                    days: scheduleData.days,
                    location: scheduleData.displayName,
                    startTime: scheduleData.startTimeFormatted,
                    endTime: scheduleData.endTimeFormatted,
                    building: scheduleData.building,
                    meetType: scheduleData.meetTypeDesc,
                }));

                course = {
                    schedule,
                    title: courseInfo.title,
                    credits: courseInfo.credits,
                    termCode: courseInfo.termCode,
                    grade: courseInfo.grade,
                    courseNumber: `${courseInfo.subjectCode} ${courseInfo.courseNumber}`,
                    instructor: courseInfo.instructorPIDM,
                };

                if (semesters[termCode]) {
                    (semesters[termCode] as Semester).courses.push(course);

                } else {
                    let term = terms[termCode];
                    semesters[termCode] = {
                        termCode,
                        courses: [course],
                        title: courseInfo.termCodeDescription,
                        isCurrent: isCurrentTerm(term)
                    };
                }
            });

            let semestersLocal: Semester[] = Object.values(semesters);
                semestersLocal = semestersLocal.sort((semesterA: Semester, semesterB: Semester) => parseInt(semesterA.termCode) < parseInt(semesterB.termCode) ? 1 : -1);

            return semestersLocal;
        }
        return [];
    };

    useEffect(() => {
       const localSemesters: Semester[] = parseSemesters(courseData, termData);

       setSemesters(localSemesters);
    }, [courseData, termData]);

    return (
        <CoursesContext.Provider value={semesters}>
            {props.children}
        </CoursesContext.Provider>
    );
}
